/* eslint-disable no-undef */
import { Navbar, TesSearch, Input } from "components";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { fetchReport } from "../../services/users.service";
// import { getLongDate } from "utils";
import LogoLoader from "components/widgets/loader/LogoLoader";
import { IPostingReport } from "types";
// import { downloadLogo } from "assets/logos";
// import { user } from "assets/images";

const ITEMS_PER_PAGE = 9;

export const PostingReportView: React.FC = () => {
  const [reports, setReports] = useState<IPostingReport[]>([]);
  const [openReportId, setOpenReportId] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [showPrevNext, setShowPrevNext] = useState<boolean>(false);
  const [currentUserIndex, setCurrentUserIndex] = useState<number>(0);
  const [searchTerm, setSearchTerm] = useState<string>("");

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const fetchedReport = await fetchReport();
        setReports(fetchedReport);
      } catch (error) {
        setError("Failed to fetch users");
      } finally {
        setLoading(false);
      }
    };

    void loadUsers();
  }, []);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setOpenReportId(null);
    setShowPrevNext(false);
    setCurrentUserIndex(0);
  };

  const handlePreviousReport = () => {
    if (currentUserIndex > 0) {
      const newIndex = currentUserIndex - 1;
      setCurrentUserIndex(newIndex);
      setOpenReportId(filteredReports[newIndex]._id ?? null);
      const newPage = Math.floor(newIndex / ITEMS_PER_PAGE) + 1;
      setCurrentPage(newPage);
    }
  };

  const handleNextReport = () => {
    if (currentUserIndex < filteredReports.length - 1) {
      const newIndex = currentUserIndex + 1;
      setCurrentUserIndex(newIndex);
      setOpenReportId(filteredReports[newIndex]._id ?? null);
      const newPage = Math.floor(newIndex / ITEMS_PER_PAGE) + 1;
      setCurrentPage(newPage);
    }
  };

  const handleToggle = (_id: string | undefined) => {
    if (_id) {
      setOpenReportId(openReportId === _id ? null : _id);
      setShowPrevNext(openReportId !== _id);
      if (openReportId !== _id) {
        const index = filteredReports.findIndex((report : any) => report._id === _id);
        setCurrentUserIndex(index);
        const newPage = Math.floor(index / ITEMS_PER_PAGE) + 1;
        setCurrentPage(newPage);
      }
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const filteredReports = reports.filter(

    (report)=> report?.sourceSchool?.toLowerCase().includes(searchTerm.toLowerCase()) ??
               report.destinationSchool?.toLowerCase().includes(searchTerm.toLowerCase()) ??
               report.newPosition?.toLowerCase().includes(searchTerm.toLowerCase()) ??
               report.previousPosition?.toLowerCase().includes(searchTerm.toLowerCase()) ??
               report.staleOrNew?.toLowerCase().includes(searchTerm.toLowerCase()) ??
               report.staffDetails?.toLowerCase().includes(searchTerm.toLowerCase())

    // (school) =>
    //   school.nameOfSchool.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //   school.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //   school.location.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) return <LogoLoader />;
  if (error) return <p>{error}</p>;

  const totalPages = Math.ceil(filteredReports.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const paginatedReports = filteredReports.slice(startIndex, endIndex);

  return (
    <>
      <Navbar />
      <div className="flex flex-col h-full w-full bg-gray-900 mt-16 gap-2 p-5">
      <h4 className="text-white"> Total Number of Users : {reports.length}</h4>
        <div className="flex flex-row w-full justify-end items-center color-white gap-1 items-right mb-4">
      
          <Input
            size="md"
            onChange={handleChange}
            value={searchTerm}
            placeholder="Search schools..."
            className="rounded-[50px] h-10 w-80 text-lg"
          />
          <TesSearch size={30} />
        </div>

        {paginatedReports.length > 0 ? (
          paginatedReports.map((report) => (
            <div
              key={report._id}
              className={`flex flex-col w-full ${
                openReportId && openReportId !== report._id ? "hidden" : ""
              }`}
            >
              <div
                className="flex flex-row justify-between items-center hover:bg-[#7ed348] hover:text-black bg-[#1b733f] text-white p-3 cursor-pointer rounded-lg shadow-md"
                onClick={() => {
                  handleToggle(report._id);
                }}
              >
                <p className="text-lg font-semibold">
              {report?.staffDetails?.toUpperCase()} 
                </p>
                <h5 className="text-xl font-bold">{openReportId === report._id ? "-" : "+"}</h5>
              </div>

              <AnimatePresence>
                {openReportId === report._id && (
                  <motion.div
                    initial={{ height: 0 }}
                    animate={{ height: "auto" }}
                    exit={{ height: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden bg-[#b8a188] text-[#60cd84] w-full p-4 rounded-lg shadow-lg mt-2"
                  >
                    <div className="bg-white p-4 rounded-lg shadow-md max-h-[500px] overflow-auto">
                      <div className="flex flex-row justify-center">
                        <h2 className="text-[30px] font-bold mb-2 text-[#1b733f]">
                          {report?.staffDetails} 
                        </h2>
                      </div>
                      <div className="flex flex-row justify-space-around mb-4 gap-4 justify-center">
                        <p className="text-gray-700 mb-1">
                          {/* <strong>Category:</strong> {school?.category} */}
                        </p>
                        <p className="text-gray-700 mb-1">
                          {/* <strong>Address:</strong> {school?.address} */}
                        </p>
                        <p className="text-gray-700 mb-1">
                          {/* <strong>Division:</strong> {school?.division} */}
                        </p>
                        <p className="text-gray-700 mb-1">
                          {/* <strong>Location:</strong> {school?.location} */}
                        </p>
                      </div>

                      <div className="flex flex-col space-y-4">
                        <div className="flex flex-wrap gap-4">
                          <div className="flex-1 bg-gray-50 p-4 rounded-lg shadow-sm">
                            <h3 className="text-lg font-semibold mb-2 text-black">Report</h3>
                          
                              <div className="text-black">
                                <p>
                                  <strong>Name:</strong> {report?.staffDetails}
                                </p>
                                <p>
                                  <strong>New Position:</strong> {report?.newPosition}
                                </p>
                                <p>
                                  <strong>Source School:</strong> {report?.sourceSchool}
                                </p>
                                <p>
                                  <strong>Destination School:</strong> {report?.destinationSchool}
                                </p>
                                {/* <p>
                                  <strong>Date of New Posting:</strong> {report?.dateOfNewSchoolPosting}
                                </p> */}
                                {/* <p>
                                  <strong>Date of Previous Posting:</strong>
                                  {report?.dateOfPreviousSchoolPosting?.toLocaleDateString()}
                                </p> */}
                                <p>
                                  <strong>Previous Position:</strong> {report?.previousPosition}
                                </p>
                                {/* <p>
                                  <strong>Date of Present Posting:</strong>
                                  {user?.dateOfPresentSchoolPosting?.toLocaleDateString()}
                                </p>
                                <p>
                                  <strong>Date of First Appointment:</strong>{" "}
                                  {user?.dateOfFirstAppointment?.toLocaleDateString()}
                                </p>
                                <p>
                                  <strong>Date of Birth:</strong>{" "}
                                  {user?.dateOfBirth?.toLocaleDateString()}
                                </p>
                                <p>
                                  <strong>Date of Retirement:</strong>{" "}
                                  {user?.dateOfRetirement?.toLocaleDateString()}
                                </p> */}
                                
                                
                                {/* <p className="text-gray-500"> <strong>Service Status:</strong>  {user.serviceStatus}</p> */}
                              </div>
                            
                            
                             {/* : (
                              <p className="text-gray-500"> {user.serviceStatus}</p>
                            )}  */}
                          </div>

                          

                         
                       
                          
                        </div>
                      </div>
                    </div>

                    <div className="mt-2 flex-1 bg-gray-50 p-4 rounded-lg shadow-sm">
                      <h5 className="text-lg font-semibold text-black">Uploaded Documents</h5>
                      {paginatedReports.length > 0 ? (
                        <ul className="list-disc pl-5 space-y-2">
                          {/* {school?.listOfStaff?.map((staff: any) => (
                            <li key={staff?._id} className="text-gray-700">
                              <p>
                                <strong>Staff Name:</strong> {staff?.staffName?.firstName}
                              </p>
                              <p>
                                <strong>Position:</strong> {staff?.position}
                              </p>
                              <p>
                                <strong>Phone:</strong> {staff?.phoneNumber}
                              </p>
                              <p>
                                <strong>OG Number:</strong> {staff?.ogNumber}
                              </p>
                              <p>
                                <strong>TSC File Number:</strong> {staff?.tscFileNumber}
                              </p>
                            </li>
                          ))} */}
                        </ul>
                      ) : (
                        <p>No report found.</p>
                      )}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))
        ) : (
          <p className="text-white text-center">No report found matching your search.</p>
        )}

        {showPrevNext && (
          <div className="flex justify-between items-center mt-4">
            <button
              onClick={handlePreviousReport}
              className="px-4 py-2 bg-[#1b733f] text-white rounded shadow-md hover:bg-[#1b733f]/80"
            >
              Previous Report
            </button>
            <span className="text-white">
              User {currentUserIndex + 1} of {filteredReports.length}
            </span>
            {currentUserIndex < filteredReports.length - 1 && (
              <button
                onClick={handleNextReport}
                className="px-4 py-2 bg-[#1b733f] text-white rounded shadow-md hover:bg-[#1b733f]/80 hover:bg-[#7ed348] hover:text-black"
              >
                Next Report
              </button>
            )}
          </div>
        )}

        {!showPrevNext && (
          <div className="flex justify-center mt-4">
            {currentPage !== 1 && (
              <button
                onClick={() => {
                  handlePageChange(currentPage - 1);
                }}
                disabled={currentPage === 1}
                className="px-4 py-2 bg-[#1b733f] text-white rounded-l shadow-md hover:bg-[#1b733f]/80 hover:bg-[#7ed348] hover:text-black"
              >
                Previous
              </button>
            )}
            <span className="px-4 py-2 bg-[#1b733f] text-white shadow-md">
              Page {currentPage} of {totalPages}
            </span>
            {currentPage !== totalPages && (
              <button
                onClick={() => {
                  handlePageChange(currentPage + 1);
                }}
                disabled={currentPage === totalPages}
                className="px-4 py-2 bg-[#1b733f] text-white rounded-r shadow-md hover:bg-[#1b733f]/80 hover:bg-[#7ed348] hover:text-black"
              >
                Next
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};
